// External Imports
import { createContext, useState, useEffect, useContext } from "react";

// Internal Imports
import { AuthContext } from "./auth-context";
import { requestAdminAPI } from "../api/posh-api";

export const DataContext = createContext({
  admin: {},
  locations: [],
  loadingData: true,
  fetchData: () => {},
  fetchAdmin: () => {},
  fetchLocations: () => {},
});

export const DataContextProvider = ({ children }) => {
  const { user, logout } = useContext(AuthContext);
  const [admin, setAdmin] = useState();
  const [locations, setLocations] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  /** ========================================================== FETCH ALL DATA */
  const fetchData = async (callback) => {
    try {
      setLoadingData(true);
      fetchAdmin(() =>
        fetchLocations(() => {
          setLoadingData(false);
          callback && callback();
        })
      );
    } catch (err) {
      setLoadingData(false);
      console.error(err);
    }
  };

  /** ========================================================== FETCH ADMIN */
  const fetchAdmin = async (callback) => {
    try {
      setLoadingData(true);
      const employee = await requestAdminAPI("fetch", {
        table: "employee",
        id: user.uid,
        columns: [
          "reminders: reminders_on_employee { id date message completed }",
        ],
      });
      setAdmin(employee);
      callback && callback();
      setLoadingData(false);
    } catch (err) {
      logout();
      setLoadingData(false);
      console.error(err);
    }
  };

  /** ========================================================== FETCH ALL LOCATIONS */
  const fetchLocations = async (callback) => {
    try {
      setLoadingData(true);
      const locations = await requestAdminAPI("fetch-all", {
        table: "location",
      });
      setLocations(locations);
      callback && callback();
      setLoadingData(false);
    } catch (err) {
      setLoadingData(false);
      console.error(err);
    }
  };

  /** ========================================================== CLEAR DATA */
  const clearData = () => {
    setAdmin({});
    setLocations([]);
  };

  useEffect(() => {
    if (user) fetchData();
    else clearData();
  }, [user]);

  return (
    <DataContext.Provider
      value={{
        admin,
        loadingData,
        locations,
        fetchData,
        fetchAdmin,
        fetchLocations,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
